import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var LoginAttemptsService = /** @class */ (function (_super) {
    tslib_1.__extends(LoginAttemptsService, _super);
    function LoginAttemptsService(http) {
        var _this = _super.call(this, http, MapperService.loginAttemptsMap) || this;
        _this._endpoint = 'odata/UserLoginAttempts';
        return _this;
    }
    return LoginAttemptsService;
}(ODataService));
export { LoginAttemptsService };
